import rotaractactivity1 from "../../../assets/CampuLifeImages/rotaractactivity1.jpg"
import rotaractactivity2 from "../../../assets/CampuLifeImages/rotaractactivity2.jpg"
import rotaractactivity3 from "../../../assets/CampuLifeImages/rotaractactivity3.jpg"
import rotaractactivity4 from "../../../assets/CampuLifeImages/rotaractactivity4.jpg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage'
import rotaractbanner from "../../../assets/CampuLifeImages/rotaractbanner.jpg"

const Rotaract = () => {
   
   const data = 
    { 
      name:"rotaract",
           pagename: "Rotaract Club", 
      hover:true,
      title: "Rotaract Club Activities",
      viewmore:"true",
      viewless:"true",
      contentImg:rotaractbanner,
      para:"Rotaract club of NICAS sponsored by the Rotary Club of Kuzhithurai Gems was started in the year 2018 and it offers a platform for young people to develop leadership and professional skills, engage in service projects, and foster friendships through various activities and events.",
      paraobjective:"Objectives :",
      objectivepoints:["Developing Leadership and Professional Skills.","Promoting Ethical Standards and Respect.","Providing Opportunities for Service.","Working in Cooperation with Rotary Clubs."],
      paraonetitle:"Our activities :",
      paraone:"Every year Rotaract club of NICAS select the President, Secretaray and Treasurer among the members. About 80 members from various departments join the Rotaract club. The club commemorates International and National Days of importance like International Girl Child Day, World Cancer Day, International Women’s Day etc at our campus. The President and Secretary of the sponsor club joins the program along with the Chief guest. Also Service projects were carried out by celebrating festivals like Christmas, Onam with inmates of charity institutions like orphanages, old age homes and so on. Environmental Awareness created among the members by conducting campus cleaning programs and plastic awareness programs. Rotaractors participate in RYLA and express their leadership skills and won awards and honours.",
      fourhover:true
    }
   
   const hoverContent =[
     {  img:  rotaractactivity1, para1: "Installation Ceremony- President and Secretary", para2: "" },
     {  img:  rotaractactivity2, para1: "Campus cleaning activities – Plastic Awareness", para2: "" },
     {  img:  rotaractactivity3, para1: "Commemorating International Girl Child Day at our Campus.", para2: "March 14, 2024" },
     {  img:  rotaractactivity4, para1: "Rotaractors celebrating Christmas with inmates of Old age Home", para2: "" }
 ]

 const tableData = [
  {title:"Rotaract Club Organizers"},
  {headings:[{heading1:"S.No",heading2:"Name",heading3:"Designation & Department",heading4:"Position"}]},
  {data:[{ id: 1, name: 'Dr. R. P. Dhanya', designDept:"HOD, Microbiology" ,pos:"Advisor"},
  
 
]},
  {padding:true}
];
  return (
    <>
   
    <ExtenStudClubGrievPage data = {data} hoverContent = {hoverContent} />
     </>
  )
}

export default Rotaract
